import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'validateDate'
})
export class ValidateDatePipe implements PipeTransform {

  transform(value: string): Date | null {
    if (typeof value !== 'string') {
      return null;
    }

    const parsedDate = new Date(value);
    
    // Check if the parsed date is valid (i.e., not "Invalid Date")
    if (isNaN(parsedDate.getTime())) {
      return null;
    }

    // Check that the value is a properly formatted date string (not a number)
    if (!/^\d{4}-\d{2}-\d{2}/.test(value)) {
      return null;
    }

    return parsedDate;
  }
}
